import * as XLSX from "xlsx";

const MAX_PREVIEW_ROWS = 500;

/**
 * Parsea CSV / XLSX / XLS sin detectar campos.
 * Devuelve los datos crudos sin ninguna inferencia de columnas.
 *
 * @param {File} file
 * @returns {Promise<{ headers: string[], rows: any[][] }>}
 *          headers = primera fila del archivo
 *          rows    = resto de filas (máx MAX_PREVIEW_ROWS)
 */
export async function parseRawFile(file) {
  const buffer = await readFileAsArrayBuffer(file);
  const workbook = XLSX.read(buffer, { type: "array" });

  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    throw new Error("El archivo no contiene hojas de datos.");
  }

  const sheet = workbook.Sheets[sheetName];
  const allRows = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    defval: "",
    blankrows: false,
  });

  if (!allRows || allRows.length === 0) {
    throw new Error("El archivo está vacío.");
  }

  // Primera fila como headers; convertir a string
  const headers = (allRows[0] || []).map((h) =>
    h != null ? String(h).trim() : ""
  );

  if (headers.every((h) => h === "")) {
    throw new Error("No se encontraron encabezados en la primera fila.");
  }

  const dataRows = allRows.slice(1, MAX_PREVIEW_ROWS + 1);

  // Normalizar filas: mismo largo que headers
  const rows = dataRows.map((row) => {
    const normalized = Array(headers.length).fill("");
    for (let i = 0; i < headers.length; i++) {
      const val = row[i];
      normalized[i] = val != null ? val : "";
    }
    return normalized;
  });

  return { headers, rows };
}

function readFileAsArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = () => reject(new Error("Error al leer el archivo."));
    reader.readAsArrayBuffer(file);
  });
}
